import { createRoot, createSignal, type Signal } from 'solid-js'
import { parse, safeParse } from 'valibot'
import { type DeviceUserPreference, DeviceUserPreferenceSchema } from './DeviceUserPreferenceSchema.type'
import getDeviceUserPreferenceFromLocalStorage from './getDeviceUserPreferenceFromLocalStorage'

export const DEVICE_USER_PREFERENCE_LS_KEY = 'dup'

function createDeviceUserPreference(): DeviceUserPreference {
  return parse(DeviceUserPreferenceSchema, {})
}

const deviceUserPreferencesSignal : Signal<DeviceUserPreference> = createRoot(() => {
  const [getValue, setValue] = createSignal(getDeviceUserPreferenceFromLocalStorage() || createDeviceUserPreference())
  // const [getDeviceUserPreference, setDeviceUserPreference] = signal

  window.addEventListener('storage', function (event) {
    if (event.key === DEVICE_USER_PREFERENCE_LS_KEY) {
      const newValue = event.newValue ? JSON.parse(event.newValue) : null
      const result = safeParse(DeviceUserPreferenceSchema, newValue)
      if (result.success) {
        setValue(result.output)
      }
    }
  })

  function setValue2 (newValue: DeviceUserPreference) {
    const newValueParsed = parse(DeviceUserPreferenceSchema, newValue)
    setValue(newValueParsed)
    localStorage.setItem(DEVICE_USER_PREFERENCE_LS_KEY, JSON.stringify(newValueParsed))
  }

  return [getValue, setValue2 as typeof setValue]
})

export const [getDeviceUserPreference, setDeviceUserPreference] = deviceUserPreferencesSignal
